import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class CaseHistoryModel extends BaseModel {
  static urlPath = "case-history";

  @attr("json") createdAt;
  @attr("json") updatedAt;
  @attr("json") createdBy;
  @attr("json") updatedBy;
  @attr("json") status;
  @attr("json") legalStatus;
  @attr("json") overallStatus;
}
